import './JobPortal.css';
import { useState, useEffect } from 'react';
import { FaClipboardList } from 'react-icons/fa';
import { logoWhiteSVG } from '../../assets';

import PortalJobListItem from '../../components/Portal/PortalJobListItem';

import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useToast } from '../../contexts/ToastContext';

import { getPortalJobs, completeJob } from '../../data/jobData';
import { mobileJobsGrid } from '../../data/interfaces';

const JobPortal = () => {
    const { showToast } = useToast();
    const [jobData, setJobData] = useState<mobileJobsGrid[]>([]);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const toggleConfirm = () => {
        setConfirmVisible(!confirmVisible);
    };

    console.log(jobData);

    const completedJobHandler = (id: number) => {
        completeJob(id).then(() => {
            const fetchData = async () => {
                const jobData = await getPortalJobs();
                setJobData(jobData);
            };
            fetchData();
        });
        showToast('Job completed', 'success');
    };

    useEffect(() => {
        const fetchData = async () => {
            const jobsData = await getPortalJobs();
            setJobData(jobsData);
        };

        fetchData();
    }, []);

    return (
        <div className="container jobportal__wrapper">
            <div className="container jobportal__header">
                <div className="row">
                    <div
                        className="col"
                        style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem', marginTop: '1rem' }}
                    >
                        <img style={{ width: '50%' }} src={logoWhiteSVG} alt="logo" />
                    </div>
                </div>
            </div>

            <div>
                {jobData.length > 0 ? (
                    <div>
                        {jobData.map((job: mobileJobsGrid) => (
                            <PortalJobListItem
                                onJobId={job.jobId}
                                onJobRef={job.refFormatted}
                                onClient={job.client}
                                onComplete={completedJobHandler}
                                onStartDate={job.startDate}
                            />
                        ))}
                    </div>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            padding: '1rem',
                            backgroundColor: 'rgb(216 229 237)',
                            borderRadius: '0.5rem',
                            alignItems: 'center',
                        }}
                    >
                        <p style={{ margin: 0 }}>No jobs assigned</p>
                    </div>
                )}
            </div>

            {confirmVisible && (
                <Dialog title={'Please confirm'} onClose={toggleConfirm}>
                    <p
                        style={{
                            margin: '25px',
                            textAlign: 'center',
                        }}
                    >
                        Are you sure you want to complete this job?
                    </p>
                    <DialogActionsBar>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleConfirm}
                        >
                            No
                        </button>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleConfirm}
                        >
                            Yes
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}
        </div>
    );
};

export default JobPortal;
